export const SportsMessageChannels = {
    Unsubscribe: "Unsubscribe",
    GetSports: "GetSports",
    GetSportsGroupedByDate: "GetSportsGroupedByDate",
    GetLeaguesBySportId: "GetLeaguesBySportId",
    GetLeaguesByLeagueId: "GetLeaguesByLeagueId",
    GetTopLeaguesBySportId: "GetTopLeaguesBySportId",
    GetEventsBySportId: "GetEventsBySportId",
    GetEventsByEventId: "GetEventsByEventId",
    GetEventsByEventIdOrByLeagueId: "GetEventsByEventIdOrByLeagueId",
    GetEventsByLeagueId: "GetEventsByLeagueId",
    GetEventsFromTopLeaguesBySportId: "GetEventsFromTopLeaguesBySportId",
    GetEventsCountByTag: "GetEventsCountByTag",
    GetEventsByRegionIdAndSportId: "GetEventsByRegionIdAndSportId",
    GetPersonalizedLiveEvents: "GetPersonalizedLiveEvents",
    GetEventsByEventIdForBetSlip: "GetEventsByEventIdForBetSlip"
};
//# sourceMappingURL=index.js.map